export default __webpack_public_path__ + "static/media/web.3508e060.svg";